module.exports = __webpack_public_path__ + "img/homepage-bestpreisgarantie.2cd4bdf.svg";